import AuthenticatedPageWrapper from '@/ui/layouts/authenticatedPageWrapper/AuthenticatedPageWrapper';
import { Alert, AnchorButton } from '@payaca/ambrosia';
import { getUrlSearchParam } from '@payaca/helpers/urlHelper';
import { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';

/** Stands in for the retired proposal builder on a legacy Project's Proposals. */
const LegacyProposalPage: FC = () => {
  const { search } = useLocation();
  const projectId = getUrlSearchParam(search, 'projectId');

  return (
    <AuthenticatedPageWrapper>
      <div className="p-4 pb-6">
        <Alert colour="blue" iconName="info-circle.3">
          The proposal is no longer visible at this page. If a PDF has been
          generated, you will be able to see it in the{' '}
          {projectId ? (
            <AnchorButton
              as={Link}
              to={`/projects/${projectId}/files`}
              variant="link"
            >
              project files tab
            </AnchorButton>
          ) : (
            'project files tab'
          )}
          .
        </Alert>
      </div>
    </AuthenticatedPageWrapper>
  );
};

export default LegacyProposalPage;
